import React, { useRef, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import doctorphoto from "./../../assets/images/sir.png";
import "bootstrap/dist/css/bootstrap.min.css";

const Appointment = () => {
  const navigate = useNavigate();

  const today = new Date();
  let day = today.getDate();
  let month = today.getMonth() + 1;
  const year = today.getFullYear();
  const hour = today.getHours();
  if (hour > 17) {
    day = (day + 1);
  }

  let maxmonth = (month + 1);
  if (maxmonth < 10) {
    maxmonth = "0" + maxmonth;
  }
  if (month < 10) {
    month = "0" + month;
  }
  if (day < 10) {
    day = "0" + (day);
  }

  const minDate = `${year}-${month}-${day}`;

  const maxDate = `${year}-${(maxmonth)}-${day}`;

  const [formDataState, setFormDataState] = useState({
    name: "",
    email: "",
    phone: "",
    //findUs: "",
    message: "",
    //date: minDate,
  });
  const [status, setStatus] = useState("");
  const [isSubmit, setIsSubmit] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormDataState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const sendEmail = async (e) => {
    setIsSubmit(true);
    e.preventDefault();

    // Prepare FormData object
    const formData = new FormData();
    formData.append("name", formDataState.name);
    formData.append("email", formDataState.email);
    formData.append("phone", formDataState.phone);
    //formData.append("findUs", formDataState.findUs);
    formData.append("message", formDataState.message);
    //formData.append("date", formDataState.date);

    try {
      const response = await axios.post("https://entdelhi.com/mailer/mailer.php", formData);
      if (response.data.success) {
        setStatus("Message sent successfully!");
        // Reset form state
        setFormDataState({
          name: "",
          email: "",
          phone: "",
          //findUs: "",
          message: "",
        });

        navigate("/thank-you");
      } else {
        setStatus("Failed to send message.");
        console.error(response.data.error);
      }
      setIsSubmit(false);
    } catch (error) {
      setStatus("Something went wrong!");
      console.error("Axios error:", error);
    }
  };
  return (
    <div>
		<section className="pq-contact-us form-map" style={{ bottom: "50px" }}>
			<div className="container mt-5">
          <div class="row g-4">
					<div class="col-md-6 ">
						<div class="row g-3 stats-row ">
							<div class="col-md-8">
								<h2>Dr. (Major) Rajesh Bhardwaj</h2>
								<h5>MBBS (AFMC), MS, DNB, DLO, DHA</h5>
								<p>Leading ENT Specialist in Delhi NCR</p>
							</div>
							<div class="col-md-4 mob-hide">
								<img src={doctorphoto} style={{ width: '100%' }} class="img-fluid rounded " alt="Hearing Test" />
							</div>
						</div>

						<div class="row g-3 stats-row mb-3">
							<div class="col">
								
								<i class="fas fa-solid fa-shield"></i>
								
								<h6>35 Years+ Experience </h6>
							</div>
							<div class="col">
								<i class="fas fa-solid fa-star"></i>
								<h6>Highly Rated</h6>
							</div>
							<div class="col">
								<i class="fas fa-solid fa-microchip"></i>
								<h6>Best Equipped</h6>
							</div>
							<div class="col">
								<i class="fas fa-solid fa-heart"></i>
								<h6>1M+<br/><small>Happy Patients</small></h6>
							</div>
						</div>
					</div>

					<div class="col-md-6">
						<div class="form-section">
							<h4 class="mb-3" style={{ fontSize: '20px', fontWeight: 'bold', textAlign: 'center' }}>Appointment with  Dr. (Major) Rajesh Bhardwaj</h4>
							<form onSubmit={sendEmail}>

								<div class="mb-3">
									<input type="text" class="form-control" placeholder="Patients Name" name="name" required value={formDataState.name} onChange={handleChange} />
								</div>

								<div class="mb-3">
									<input type="email" class="form-control" placeholder="Enter your email" name="email" required value={formDataState.email} onChange={handleChange} />
								</div>

								<div class="mb-3">
									<input id="phone" type="tel" class="form-control" placeholder="Your Phone Number" name="phone" required value={formDataState.phone} onChange={handleChange} maxLength="13" onInput={(e) => {
										e.target.value = e.target.value.replace(/\D/g, "");
									}} />
								</div>

								<div class="mb-3">
									<textarea id="message" class="form-control" name="message" rows="3" cols="40" placeholder="Describe Your Problems" value={formDataState.message} onChange={handleChange}></textarea>

								</div>

								<div className="mb-2">
									<div className="form-check">									
										<input class="form-check-input" type="checkbox" id="policy" required />
										<label className="form-check-label" htmlFor="policy">
										I agree to the terms in the <a href="#">Privacy Policy</a>
										</label>
									</div>
									<div class="form-check">
										<input class="form-check-input" type="checkbox" id="offers" required />
										<label class="form-check-label" htmlFor="offers">
											I would like MedFirst ENT Centre to send me information about ENT solutions, services and offers.
										</label>
									</div>
								</div>
								{/*<button type="submit" class="btn btn-submit mt-2">Book Appointment Now</button>*/}
								{!isSubmit && <button type="submit" class="btn btn-submit mt-2">Book Appointment Now</button>}
								{isSubmit && 
									<button type="submit" disabled={true}>Booking
										<div class="ms-4 spinner-border text-light" role="status">
											<span class="sr-only">Loading...</span>
										</div>
									</button>
								}
							</form>
						</div>
					</div>
				</div>
			</div>
		</section>
    </div>
  );
};

export default Appointment;
